import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';

// eslint-disable-next-line import/no-cycle
import centralizedIssues from '@/store/centralizedIssues';
// eslint-disable-next-line import/no-cycle
import auth from './auth';
// eslint-disable-next-line import/no-cycle
import spFreelancerRegistration from './spFreelancerRegistration';
// eslint-disable-next-line import/no-cycle
import user from './user';
// eslint-disable-next-line import/no-cycle
import task from './task';
// eslint-disable-next-line import/no-cycle
import issue from './issue';
// eslint-disable-next-line import/no-cycle
import project from './project';
// eslint-disable-next-line import/no-cycle
import request from './request';
import newProject from './newProject';
// eslint-disable-next-line import/no-cycle
import registration from './registration';
// eslint-disable-next-line import/no-cycle
import spWorkerRegistration from './spWorkerRegistration';
// eslint-disable-next-line import/no-cycle
import spCompanyRegistration from './spCompanyRegistration';
// eslint-disable-next-line import/no-cycle
import notification from './notification';
// eslint-disable-next-line import/no-cycle
import filters from './filters';
// eslint-disable-next-line import/no-cycle
import statistics from './statistics';
// eslint-disable-next-line import/no-cycle
import workflow from './workflow';
// eslint-disable-next-line import/no-cycle
import pagination from './pagination';
// eslint-disable-next-line import/no-cycle
import activity from './activity';
// eslint-disable-next-line import/no-cycle
import integration from './integration';
// eslint-disable-next-line import/no-cycle
import reports from './reports';
// eslint-disable-next-line import/no-cycle
import apiKeys from './apiKeys';
// eslint-disable-next-line import/no-cycle
import configuration from './configuration';
// eslint-disable-next-line import/no-cycle
import insights from './insights';
// eslint-disable-next-line import/no-cycle
// eslint-disable-next-line import/no-cycle
import license from './license';
// eslint-disable-next-line import/no-cycle
import organization from './organization';
import theme from './theme';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      reducer: state => ({
        newProject: state.newProject,
        registration: state.registration,
        pagination: state.pagination,
      }),
    }),
  ],
  modules: {
    spWorkerRegistration,
    spCompanyRegistration,
    spFreelancerRegistration,
    pagination,
    auth,
    user,
    task,
    issue,
    project,
    request,
    newProject,
    registration,
    filters,
    notification,
    statistics,
    workflow,
    activity,
    centralizedIssues,
    integration,
    reports,
    apiKeys,
    configuration,
    insights,
    license,
    organization,
    theme,
  },
});
